import { HttpClient } from '@angular/common/http';
import { Injectable, Injector, EventEmitter } from '@angular/core';
import { map } from 'rxjs/operators';
import { createHttpParams } from '~/infrastructure/http/params';
import { augmentPaging } from '~/infrastructure/paging';
import { ApiServiceBase, API_NAMES } from '~/services/api';
import { CustomerType } from './../../../models/modules/customerType';
@Injectable({
  providedIn: 'root'
})
export class CustomerTypesService extends ApiServiceBase {
  customerTypeAdded: EventEmitter<any> = new EventEmitter();
  constructor(injector: Injector, private http: HttpClient) {
    super(injector);
    this.setBase(API_NAMES.stocks);
  }

  deactivateCustomerType(obj: any) {
    return this.client.put(this._url(`/deactivate`), obj);
  }

  getCustomerTypeListing() {
    return this.http.get<CustomerType[]>(this._url());
  }

  getCustomerTypeByID(id: number) {
    return this.http.get<CustomerType>(this._url(`/${id}`));
  }


  createCustomerType(model: any) {
    return this.client.post<string>(this._url(), model);
  }

  deactivateCustomerTypeBatch(obj: any) {
    return this.client.put(this._url(`/batchDeactivate`), obj);
  }

  reactivateCustomerType(obj: any) {
    return this.client.put(this._url(`/reactivate`), obj);
  }
  getCustomerTypedatagrid(paramsObj?: any, model?: any) {
    paramsObj = paramsObj || {};
    paramsObj.view = 'summary';
    let params = createHttpParams(paramsObj);

    return this.http
      .post<CustomerType[]>(this._url(`/grid-data`), model, {
        params,
        observe: 'response',
      })
      .pipe(map(augmentPaging));
  }

  updateCustomerType(id: number, model: any) {
    return this.client.put(this._url(`/${id}`), model);
  }



  private _url(v?: string | undefined) {
    v = v || '';
    return this.url(`/CustomerTypes${v}`);
  }
}
